















import Vue from 'vue';
import SInputText from '../SInputText/SInputText.vue';

/**
 * A set of controls for filtering a list or table. It doesn't do much more than layout,
 * you can pass your complex filter controls in to the default slot.
 */
export default Vue.extend({
  name: 'SFilters',
  components: {
    SInputText,
  },
  props: {
    placeholder: {
      type: String,
      default: 'Search…',
      required: false,
    },
  },
  data() {
    return {
      filterValue: '',
    };
  },
});
